module.exports = __webpack_public_path__ + "media/images/heading-mv-cm-568827a752736fb9852e34c14522c305.svg";